<template>
  <b-dropdown
    ref="bDropdown"
    :model-value="value"
    :position="position"
    :aria-role="ariaRole"
    :triggers="triggers"
    :disabled="disabled"
    :can-close="canClose"
    :append-to-body="appendToBody"
    :multiple="multiple"
    :mobile-modal="mobileModal"
    @active-change="onActiveChange"
    @update:model-value="onInput"
  >
    <template #trigger="{ active }">
      <slot name="trigger" :active="active" />
    </template>
    <slot />
  </b-dropdown>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DropdownView',
  emits: ['active-change', 'input'],
  slotsDefinition: {
    trigger: { active: Boolean }
  },
  props: {
    value: {
      type: [Object, String, Number, Boolean, Array],
      default: null
    },
    position: {
      type: String,
      validator(value) {
        return ['is-top-right', 'is-top-left', 'is-bottom-left', 'is-bottom-right'].includes(value);
      },
      default: 'is-bottom-right'
    },
    ariaRole: {
      type: String
    },
    triggers: {
      type: Array,
      default: () => ['click']
    },
    disabled: {
      type: Boolean,
      default: false
    },
    canClose: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    mobileModal: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onActiveChange(...args) {
      this.$emit('active-change', ...args);
    },
    onInput(...args) {
      this.$emit('input', ...args);
    },
    toggle() {
      this.$refs.bDropdown?.toggle?.();
    }
  }
};
</script>
